import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-t from-black via-zinc-900 to-black text-white py-12 inset-x-0 bottom-0">
      <div className="container mx-auto flex flex-col items-center">
        <p>Powered by: </p>
        <div className="mb-4">
          <a href="https://isilive.ca">
            <img
              src="/isilive_logo.png" // Update with your logo path
              alt="iSiLIVE Logo"
              className="w-50 h-20 object-cover"
            />
          </a>
        </div>
        <div className="flex flex-wrap justify-center space-x-4 md:space-x-6">
          <Link
            to="https://www.ofcfootball.ca/"
            className="text-gray-400 hover:text-white"
          >
            OFC Website
          </Link>
          <Link to="/fc/testpage" className="text-gray-400 hover:text-white">
            Test Your Connection
          </Link>
          <Link
            to="/systemrequirements"
            className="text-gray-400 hover:text-white"
          >
            System Requirements
          </Link>
          {/*           <Link to="/terms" className="text-gray-400 hover:text-white">
            Terms and Conditions
          </Link> */}
          <Link to="/privacy" className="text-gray-400 hover:text-white">
            Privacy
          </Link>
          <Link to="/faq" className="text-gray-400 hover:text-white">
            F.A.Q.
          </Link>
        </div>
        <div className="flex space-x-6 pt-6 text-gray-600 text-center text-sm sm:text-xs">
          Copyright ©2024 ISiLIVE | All Rights Reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
